export const settingsWorkspaceEn = {
  "size": "{{width}} × {{height}} mm",
  "history": "Configuration history",
  "historyHint": "Latest 100 events since this release. Field names, actor and time are recorded; bank account values are not included in this history.",
  "historyError": "Could not load configuration history.",
  "noHistory": "No configuration changes recorded yet.",
  "system": "System / legacy",
  "action_created": "Created",
  "action_updated": "Updated",
  "invalid": "Review the fields in this section. Required values must be filled and label dimensions must be whole numbers from 20 to 100 mm.",
  "invalidGeneric": "Review the fields in this section: required values must be filled in with valid values.",
  "unsaved": "Unsaved changes",
  "discard": "Discard changes",
  "changed": "Settings changed since you started editing. Your draft has been kept; load the latest settings before saving.",
  "reloadDiscard": "Discard drafts and load latest",
  "search": "Find a dictionary",
  "searchHint": "Search group names or configured values",
  "newOption": "Enter a new option",
  "labelRotateHint": "Leave this OFF unless a test label comes out sideways AND the size is otherwise correct. It does NOT change the label size — it flips the page for printers whose driver disagrees about which side is the width. Tested 20/09/2026 on the CLabel CT321D: it does not help there; print through the operating system dialog instead (see the manual). The preview turns with it, so try one test label before printing a batch.",
  "labelHint": "Use whole-number dimensions from 20 to 100 mm. Preview and test printing use the displayed draft size.",
  "testDescription": "Settings test label",
  "printTest": "Print one test label",
  "printError": "Could not open the print dialog. Allow pop-ups and try again.",
  "leaveHint": "There are unsaved changes. Discard them and continue?",
  "stay": "Keep editing",
  "leave": "Discard and leave",
  "finishCompany": "Finish or cancel the payment-company form before changing tabs.",
  "bankImpact": "Payment details used on documents. Issued snapshots are retained; older documents without a snapshot may use current details.",
  "includeInactive": "Show inactive companies",
  "inactive": "Inactive",
  "active": "Active",
  "bankIncomplete": "Bank details not configured",
  "editCompany": "Edit {{name}}",
  "defaultProtection": "Choose another default company before deactivating this one.",
  "reviewBank": "I have checked these payment details and understand changes can affect document output and the default selection.",
  "settings_changed": "Settings changed. Load the latest values and review your draft.",
  "company_changed": "This company changed. Close and reopen it to load the latest details.",
  "settings_default_invalid": "The default currency and product unit must belong to their configured dictionaries. Save dictionary changes first.",
  "settings_option_in_use": "This option is still used by existing records and cannot be removed:",
  "settings_options_required": "Product types, product units and currencies must each contain at least one option.",
  "settings_label_invalid": "Choose a valid label size from 20 to 100 mm.",
  "company_default_required": "An active default company is required. Select another default first.",
  "field_company_info": "Company information",
  "field_business_operations": "Dictionaries",
  "field_system": "Defaults",
  "field_label_printer": "Label printer",
  "field_beneficiary": "Beneficiary",
  "field_beneficiary_bank": "Bank",
  "field_bank_address": "Bank address",
  "field_account_number_hkd": "HKD account",
  "field_account_number_usd": "USD account",
  "field_account_number_rmb": "RMB account",
  "field_swift_code": "SWIFT",
  "field_logo_url": "Logo",
  "field_logo_key": "Logo file",
  "field_is_default": "Default company",
  "field_active": "Active status",
  "counter_pi": "Proforma invoice",
  "counter_invoice": "Invoice",
  "counter_dn": "Delivery note",
  "counter_pkl": "Packing list",
  "counter_po": "Purchase order",
  "counter_product": "Product",
  "counter_quotation": "Quotation",
  "counter_sample_card": "Sample card",
  "counter_sample_order": "Sample order",
  "counter_product-stock-adjustment": "Stock adjustment"
};
export const settingsWorkspaceVi = {
  "size": "{{width}} × {{height}} mm",
  "history": "Lịch sử cấu hình",
  "historyHint": "100 sự kiện gần nhất kể từ phiên bản này. Ghi tên trường, người thực hiện và thời gian; không hiển thị giá trị tài khoản ngân hàng trong lịch sử.",
  "historyError": "Không tải được lịch sử cấu hình.",
  "noHistory": "Chưa có thay đổi cấu hình được ghi nhận.",
  "system": "Hệ thống / dữ liệu cũ",
  "action_created": "Tạo",
  "action_updated": "Cập nhật",
  "invalid": "Kiểm tra các trường trong phần này. Điền giá trị bắt buộc; kích thước tem phải là số nguyên từ 20 đến 100 mm.",
  "invalidGeneric": "Kiểm tra các trường trong phần này: điền đủ giá trị bắt buộc và đúng định dạng.",
  "unsaved": "Có thay đổi chưa lưu",
  "discard": "Bỏ thay đổi",
  "changed": "Cấu hình đã thay đổi kể từ khi bạn bắt đầu sửa. Bản nháp vẫn được giữ; hãy tải cấu hình mới nhất trước khi lưu.",
  "reloadDiscard": "Bỏ bản nháp và tải mới nhất",
  "search": "Tìm nhóm danh mục",
  "searchHint": "Tìm tên nhóm hoặc giá trị đã cấu hình",
  "newOption": "Nhập lựa chọn mới",
  "labelRotateHint": "Cứ để TẮT, trừ khi in thử ra tem bị nằm ngang mà kích thước thì đúng. Ô này KHÔNG đổi khổ tem — nó lật trang cho những máy in có driver hiểu ngược chiều nào là chiều rộng. Đã thử 20/09/2026 trên máy CLabel CT321D: không giúp được gì, máy đó phải in qua hộp thoại của hệ điều hành (xem tài liệu hướng dẫn). Bản xem trước xoay theo, nên in thử một tem trước khi in cả xấp.",
  "labelHint": "Nhập số nguyên từ 20 đến 100 mm. Xem trước và in thử dùng kích thước đang hiển thị trong bản nháp.",
  "testDescription": "Tem thử cấu hình",
  "printTest": "In một tem thử",
  "printError": "Không mở được hộp thoại in. Hãy cho phép cửa sổ bật lên rồi thử lại.",
  "leaveHint": "Có thay đổi chưa lưu. Bỏ thay đổi và tiếp tục?",
  "stay": "Tiếp tục sửa",
  "leave": "Bỏ thay đổi và rời trang",
  "finishCompany": "Hoàn tất hoặc hủy form công ty thanh toán trước khi đổi tab.",
  "bankImpact": "Thông tin thanh toán dùng trên chứng từ. Bản chụp đã phát hành được giữ nguyên; chứng từ cũ chưa có bản chụp có thể dùng thông tin hiện tại.",
  "includeInactive": "Hiện công ty ngừng sử dụng",
  "inactive": "Ngừng sử dụng",
  "active": "Đang sử dụng",
  "bankIncomplete": "Chưa cấu hình ngân hàng",
  "editCompany": "Sửa {{name}}",
  "defaultProtection": "Chọn công ty mặc định khác trước khi ngừng sử dụng công ty này.",
  "reviewBank": "Tôi đã kiểm tra thông tin thanh toán và hiểu thay đổi có thể ảnh hưởng nội dung in chứng từ và lựa chọn mặc định.",
  "settings_changed": "Cấu hình đã thay đổi. Tải giá trị mới nhất và kiểm tra lại bản nháp.",
  "company_changed": "Công ty đã được cập nhật. Đóng và mở lại để tải thông tin mới nhất.",
  "settings_default_invalid": "Tiền tệ và đơn vị mặc định phải có trong danh mục tương ứng. Hãy lưu thay đổi danh mục trước.",
  "settings_option_in_use": "Lựa chọn này đang được dùng trong dữ liệu và không thể xóa:",
  "settings_options_required": "Loại sản phẩm, đơn vị sản phẩm và tiền tệ phải có ít nhất một lựa chọn.",
  "settings_label_invalid": "Chọn khổ tem hợp lệ từ 20 đến 100 mm.",
  "company_default_required": "Phải có công ty mặc định đang sử dụng. Hãy chọn công ty mặc định khác trước.",
  "field_company_info": "Thông tin công ty",
  "field_business_operations": "Danh mục",
  "field_system": "Giá trị mặc định",
  "field_label_printer": "Máy in tem",
  "field_beneficiary": "Người thụ hưởng",
  "field_beneficiary_bank": "Ngân hàng",
  "field_bank_address": "Địa chỉ ngân hàng",
  "field_account_number_hkd": "Tài khoản HKD",
  "field_account_number_usd": "Tài khoản USD",
  "field_account_number_rmb": "Tài khoản RMB",
  "field_swift_code": "SWIFT",
  "field_logo_url": "Logo",
  "field_logo_key": "Tệp logo",
  "field_is_default": "Công ty mặc định",
  "field_active": "Trạng thái sử dụng",
  "counter_pi": "Hóa đơn chiếu lệ",
  "counter_invoice": "Hóa đơn",
  "counter_dn": "Phiếu giao hàng",
  "counter_pkl": "Phiếu đóng gói",
  "counter_po": "Đơn mua hàng",
  "counter_product": "Sản phẩm",
  "counter_quotation": "Báo giá",
  "counter_sample_card": "Thẻ mẫu",
  "counter_sample_order": "Đơn mẫu",
  "counter_product-stock-adjustment": "Điều chỉnh kho"
};
export const settingsWorkspaceZh = {
  "size": "{{width}} × {{height}} mm",
  "history": "设置记录",
  "historyHint": "自此版本起最近100个事件。记录字段名称、操作者及时间，不显示银行账号值。",
  "historyError": "无法加载设置记录。",
  "noHistory": "尚无设置变更记录。",
  "system": "系统 / 旧数据",
  "action_created": "创建",
  "action_updated": "更新",
  "invalid": "请检查此区域的字段。必填项不能为空，标签尺寸必须为20至100毫米的整数。",
  "invalidGeneric": "请检查此区域的字段：必填项须填写有效的值。",
  "unsaved": "有未保存的变更",
  "discard": "放弃变更",
  "changed": "编辑期间设置已变更。草稿已保留，请先加载最新设置。",
  "reloadDiscard": "放弃草稿并加载最新设置",
  "search": "搜索选项分组",
  "searchHint": "搜索分组名称或现有选项",
  "newOption": "输入新选项",
  "labelRotateHint": "请保持关闭，除非测试标签印成横向而尺寸本身正确。此选项“不会”改变标签尺寸——它为驱动对“宽度”认定相反的打印机翻转页面。2026/09/20 于 CLabel CT321D 实测：该机型无效，请改用操作系统的打印对话框（见使用手册）。预览会一并旋转，批量打印前请先试印一张。",
  "labelHint": "请输入20至100毫米的整数。预览及测试打印使用目前草稿尺寸。",
  "testDescription": "设置测试标签",
  "printTest": "打印一张测试标签",
  "printError": "无法打开打印窗口，请允许弹出窗口后重试。",
  "leaveHint": "有未保存的变更，是否放弃并继续？",
  "stay": "继续编辑",
  "leave": "放弃并离开",
  "finishCompany": "请先完成或取消收款公司表单再切换标签页。",
  "bankImpact": "付款信息用于单据。已发布的快照维持不变，尚无快照的旧单据可能使用目前数据。",
  "includeInactive": "显示停用公司",
  "inactive": "停用",
  "active": "启用",
  "bankIncomplete": "尚未设置银行信息",
  "editCompany": "编辑 {{name}}",
  "defaultProtection": "停用前请先选择其他默认公司。",
  "reviewBank": "我已检查付款信息，并了解变更可能影响单据输出及默认选择。",
  "settings_changed": "设置已变更，请加载最新数据并检查草稿。",
  "company_changed": "此公司已变更，请关闭并重新打开以加载最新数据。",
  "settings_default_invalid": "默认币种与产品单位必须在相应选项中。请先保存选项变更。",
  "settings_option_in_use": "现有数据仍使用此选项，无法移除：",
  "settings_options_required": "产品类型、单位及币种各至少需要一个选项。",
  "settings_label_invalid": "请选择20至100毫米的有效标签尺寸。",
  "company_default_required": "必须有启用的默认公司，请先选择其他默认公司。",
  "field_company_info": "公司信息",
  "field_business_operations": "选项分组",
  "field_system": "默认值",
  "field_label_printer": "标签打印",
  "field_beneficiary": "收款人",
  "field_beneficiary_bank": "银行",
  "field_bank_address": "银行地址",
  "field_account_number_hkd": "港元账户",
  "field_account_number_usd": "美元账户",
  "field_account_number_rmb": "人民币账户",
  "field_swift_code": "SWIFT",
  "field_logo_url": "标志",
  "field_logo_key": "标志文件",
  "field_is_default": "默认公司",
  "field_active": "启用状态",
  "counter_pi": "形式发票",
  "counter_invoice": "发票",
  "counter_dn": "送货单",
  "counter_pkl": "装箱单",
  "counter_po": "采购单",
  "counter_product": "产品",
  "counter_quotation": "报价",
  "counter_sample_card": "样品卡",
  "counter_sample_order": "样品单",
  "counter_product-stock-adjustment": "库存调整"
};